export const commaSeperateList = (...stringItems: string[]): string =>
  stringItems.reduce((newString, string) => {
    if (!string || string === 'undefined') return newString;
    if (newString === '') return string;
    return `${newString}, ${string}`;
  }, '');
